// Redux
import store from '../../../store';

// Custom Icons
import CalendarIcon from 'components/Icons/calendarIcon';

import { DateCnt } from './taskListView.style';
import DateTime from 'utils/DateTime';
import { DEFAULT_TIMEZONE } from 'utils/globalVariable';
const DateRenderer = ({ date }) => {
  const tz =
    store.getState()?.authData?.user?.Hotel?.timezone || DEFAULT_TIMEZONE;
  return (
    <DateCnt>
      <CalendarIcon />
      <span>
        {date
          ? DateTime.fromUTCString(date).toTzString(tz, 'MMM DD, YYYY')
          : '-'}
      </span>
    </DateCnt>
  );
};

export default DateRenderer;
